import { REPORT_SOURCE_TYPES, TableDataType } from '../hooks';
import { GetIssueCategoriesByDepartmentGraphQuery } from 'src/graphql';
import { REPORT_SOURCE } from 'src/types';
import { roundPercentages } from 'src/utils';

export const flattenDonutAndBarGraphData = (
  data: GetIssueCategoriesByDepartmentGraphQuery['getIssueCategoriesByDepartmentGraph']['data'],
  groupType: 'intake' | 'department',
) => {
  return data.reduce((acc, cur) => {
    const categoryPercentages = cur.categories.map((c) =>
      cur.total ? (c.total * 100) / cur.total : 0,
    );
    const roundedCategoryPercentages = roundPercentages(categoryPercentages);
    const categoryData = cur.categories.map((c, i) => ({
      cellData: [
        groupType === 'intake'
          ? REPORT_SOURCE[cur.donutSegment as REPORT_SOURCE_TYPES]
          : cur.donutSegment,
        c.category,
        c.total,
        `${roundedCategoryPercentages[i]}%`,
      ],
      row: `${cur.donutSegment}-${c.category}`,
    }));
    return [...acc, ...categoryData];
  }, [] as TableDataType[]);
};
